export class StatisticsController {
    constructor($scope) {

    }
}

export const STATISTICS_CONTROLLER = ['$scope', StatisticsController];